import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";


export class StoreBundleConfig extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(StoreBundleConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(StoreBundleConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._bundle = null;
        this._active = false;
        this._points = null;
        this._google_store_id = null;
        this._google_store_option_id = null;
    }

    get bundle() {
        return this._bundle;
    }

    set bundle(value) {
        this._bundle = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    get active() {
        return this._active;
    }

    set active(value) {
        this._active = value;
    }

    set google_store_id(value) {
        this._google_store_id = value;
    }

    get google_store_id() {
        return this._google_store_id;
    }

    set google_store_option_id(value) {
        this._google_store_option_id = value;
    }

    get google_store_option_id() {
        return this._google_store_option_id;
    }

    valid() {

        if (!this.bundle || this.bundle.length <= 0) {
            return false;
        }

        if (!Number.isInteger(this.points) || this.points <= 0) {
            return false;
        }

        return true;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new StoreBundleConfig());
        } else if (target instanceof StoreBundleConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(StoreBundleConfig, {
    _export: alias("export", custom(
        () => SKIP,
        () => false
    )),
    _locked: alias("locked", custom(
        () => SKIP,
        () => false
    )),
    _enabled: alias("enabled", custom(
        () => SKIP,
        () => true
    )),
    _bundle: alias("bundle", Schema.primitive()),
    _active: alias("active", Schema.primitive()),
    _points: alias("points", Schema.primitive()),
    _google_store_id: alias("google_store_id", Schema.primitive()),
    _google_store_option_id: alias("google_store_option_id", Schema.primitive()),
});
